function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash.isempty';
import { ChevronDown, ChevronForward } from '@mediahuis/chameleon-theme-wl/icons';
import { Box, Button, Checkbox, TextField, LinkText, Paragraph, Icon, Logo } from '@mediahuis/chameleon-react';
import { noop } from '../utils';
import { ACTIVATION_ERROR, MULTIBRAND_ACTIVATION, MULTIBRAND_SUCCESS } from '../constants/steps';
import { trackingOnMountVariables } from '../trackingVariables';
import { multiBrandActivationValidation } from './validation';
import { getLanguage } from './language';
import AboPaper from '../components/AboPaper';
import { getAccountManagementUrl, getAuthUrl, getMultiBrandActivationUrl, getPlusFaqUrl } from '../../../utils/config-helper';
import { post } from '../utils/api-utils';
import { getServiceUrl } from '../../../utils/config-helper';
import { MultibrandLogos } from './MultibrandLogos';
import { PlusInfo, PlusInfoHeader, PlusInfoHeaderLogoContainer, PlusInfoHeaderLogoContainerAlt, ShowPasswordToggleButton, CollapseMoreInfo, CollapseMoreInfoButton, MoreInfoLink } from './styles';
/**
 * @param user
 * @param track
 * @param setStatus
 * @param {SRConfig} config
 * @return {JSX.Element}
 * @constructor
 */

var MultiBrandActivation = function MultiBrandActivation(_ref) {
  var _ref$authToken = _ref.authToken,
      authToken = _ref$authToken === void 0 ? '' : _ref$authToken,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$track = _ref.track,
      track = _ref$track === void 0 ? noop : _ref$track,
      _ref$setStatus = _ref.setStatus,
      setStatus = _ref$setStatus === void 0 ? noop : _ref$setStatus,
      config = _ref.config;
  var language = getLanguage();
  var Intro = language.Intro,
      Terms = language.Terms,
      MoreInfo = language.MoreInfo,
      Cta = language.Cta;

  var _useState = useState({}),
      errors = _useState[0],
      setErrors = _useState[1];

  var _useState2 = useState(user.email ? user.email : null),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = useState(null),
      password = _useState3[0],
      setPassword = _useState3[1];

  var _useState4 = useState(false),
      hasAcceptedPolicy = _useState4[0],
      setHasAcceptedPolicy = _useState4[1];

  var _useState5 = useState(false),
      isLoading = _useState5[0],
      setIsLoading = _useState5[1];

  var _useState6 = useState(false),
      showPassword = _useState6[0],
      setShowPassword = _useState6[1];

  var _useState7 = useState(false),
      showMoreInfo = _useState7[0],
      setShowMoreInfo = _useState7[1];

  useEffect(function () {
    track(trackingOnMountVariables[MULTIBRAND_ACTIVATION]({
      /* eslint-disable babel/camelcase */
      identity_accountid: user.accountId
      /* eslint-enable babel/camelcase */

    }));
  }, [user, track]);

  var checkCredentials = function checkCredentials(email, password) {
    try {
      return Promise.resolve(fetch("" + getAuthUrl(config), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: email,
          password: password
        })
      }).catch(function () {
        return setStatus(ACTIVATION_ERROR);
      })).then(function (response) {
        return Promise.resolve(response.json());
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var modifyPasswordMultibrand = function modifyPasswordMultibrand(email) {
    try {
      return Promise.resolve(post({
        url: getAccountManagementUrl(config) + "/mail/modifyPasswordMultibrand",
        data: {
          mail: email,
          goto: "https://" + (config.apiPrefix ? config.apiPrefix + "." : '') + config.siteUrl + "/activeer",
          brand: MH_BRAND,
          step: 0
        }
      }).catch(function () {
        return setStatus(ACTIVATION_ERROR);
      })).then(function (response) {
        return Promise.resolve(response.text());
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var activateMultiBrand = function activateMultiBrand(password) {
    try {
      return Promise.resolve(post({
        url: "" + getMultiBrandActivationUrl(config),
        authToken: authToken,
        options: {
          credentials: 'include'
        },
        data: {
          brand: MH_BRAND,
          password: password
        }
      }).catch(function () {
        return setStatus(ACTIVATION_ERROR);
      })).then(function (response) {
        if (response.ok) {
          setStatus(MULTIBRAND_SUCCESS);
          setIsLoading(false);
          return;
        }

        setStatus(ACTIVATION_ERROR);
        setIsLoading(false);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handlePasswordReset = function handlePasswordReset() {
    return Promise.resolve(modifyPasswordMultibrand(email)).then(function (hash) {
      if (hash) {
        window.location.replace("https://" + (config.apiPrefix ? config.apiPrefix + "." : '') + config.siteUrl + "/account/ForgotPassword?hash=" + hash + "&goto=https%3A%2F%2F" + (config.apiPrefix ? config.apiPrefix + "." : '') + config.siteUrl + "%2Factiveer");
      }
    });
  };

  var handleNext = function handleNext() {
    try {
      var multiBrandActivationErrors = multiBrandActivationValidation({
        email: email,
        password: password,
        hasAcceptedPolicy: hasAcceptedPolicy,
        handlePasswordReset: handlePasswordReset
      });
      setErrors(_extends({}, multiBrandActivationErrors));

      if (!isEmpty(multiBrandActivationErrors)) {
        return Promise.resolve();
      }

      setIsLoading(true);
      return Promise.resolve(checkCredentials(email, password)).then(function (checkCredentialsResponse) {
        if (!checkCredentialsResponse.authenticated) {
          setErrors(_extends({}, multiBrandActivationErrors, {
            password: 'Fout wachtwoord'
          }));
          setIsLoading(false);
          return;
        }

        return Promise.resolve(activateMultiBrand(password)).then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var clearError = function clearError(e) {
    var spreadedErrors = _extends({}, errors);

    delete spreadedErrors[e.target.id];
    setErrors(spreadedErrors);
  };

  return /*#__PURE__*/React.createElement(AboPaper, null, /*#__PURE__*/React.createElement(PlusInfo, null, /*#__PURE__*/React.createElement(PlusInfoHeader, null, /*#__PURE__*/React.createElement(PlusInfoHeaderLogoContainer, null, /*#__PURE__*/React.createElement(Logo, {
    height: 9,
    name: "subscriptions.plus-icon-name-inverse"
  })), /*#__PURE__*/React.createElement(PlusInfoHeaderLogoContainerAlt, null, /*#__PURE__*/React.createElement(Logo, {
    height: 9,
    name: "subscriptions.plus-icon-name"
  }))), /*#__PURE__*/React.createElement(Paragraph, null, language.headerText), /*#__PURE__*/React.createElement(MultibrandLogos, {
    activeBrand: MH_BRAND
  })), /*#__PURE__*/React.createElement(Intro, {
    mb: 8
  }), /*#__PURE__*/React.createElement(Box, {
    mb: 5
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "email",
    label: language.email,
    defaultValue: email,
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    },
    onFocus: clearError,
    message: errors.email,
    error: !!errors.email,
    disabled: true
  })), /*#__PURE__*/React.createElement(Box, {
    mb: 5,
    position: "relative"
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "password",
    label: language.password,
    defaultValue: password,
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    },
    onFocus: clearError,
    message: errors.password,
    error: !!errors.password,
    type: showPassword ? 'text' : 'password',
    action: /*#__PURE__*/React.createElement(ShowPasswordToggleButton, {
      onClick: function onClick() {
        return setShowPassword(function (prev) {
          return !prev;
        });
      }
    }, showPassword ? 'Verberg' : 'Toon')
  }), /*#__PURE__*/React.createElement(LinkText, {
    onClick: handlePasswordReset
  }, /*#__PURE__*/React.createElement(Paragraph, {
    size: "Caption1",
    textAlign: "right"
  }, language.forgotPassword))), /*#__PURE__*/React.createElement(Box, {
    mb: 5
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: hasAcceptedPolicy,
    "data-testid": "checkbox-terms",
    id: "hasAcceptedPolicy",
    label: /*#__PURE__*/React.createElement(Terms, null),
    mt: 5,
    mb: 5,
    onChange: function onChange(event) {
      return setHasAcceptedPolicy(event.target.checked);
    },
    onFocus: clearError,
    message: errors.hasAcceptedPolicy,
    error: !!errors.hasAcceptedPolicy
  })), /*#__PURE__*/React.createElement(Button, {
    width: "full",
    onClick: handleNext,
    mb: 2,
    "data-testid": "cta-multi-brand-activation",
    iconRight: ChevronForward,
    loading: isLoading
  }, /*#__PURE__*/React.createElement(Cta, null)), isLoading && /*#__PURE__*/React.createElement(Paragraph, {
    textAlign: "center"
  }, language.loading), /*#__PURE__*/React.createElement(CollapseMoreInfoButton, {
    mt: 8,
    onClick: function onClick() {
      return setShowMoreInfo(function (prev) {
        return !prev;
      });
    }
  }, "Meer informatie over +PLUS", ' ', /*#__PURE__*/React.createElement(Icon, {
    as: showMoreInfo ? ChevronDown : ChevronForward
  })), showMoreInfo && /*#__PURE__*/React.createElement(CollapseMoreInfo, null, /*#__PURE__*/React.createElement(MoreInfo, {
    email: user.email
  }), /*#__PURE__*/React.createElement(MoreInfoLink, {
    href: getPlusFaqUrl(config),
    target: "_blank",
    mt: 6
  }, "Veelgestelde vragen over +PLUS ", '>'), /*#__PURE__*/React.createElement(MoreInfoLink, {
    href: getServiceUrl(config),
    target: "_blank",
    mt: 6
  }, "Contacteer klantenservice ", '>')));
};

export default MultiBrandActivation;